import { render, staticRenderFns } from "./ScrollColumnBtnTable.vue?vue&type=template&id=6ad6212c"
import script from "./ScrollColumnBtnTable.vue?vue&type=script&lang=js"
export * from "./ScrollColumnBtnTable.vue?vue&type=script&lang=js"
import style0 from "./ScrollColumnBtnTable.vue?vue&type=style&index=0&id=6ad6212c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports